import type { EntityDashboardProviderData } from '@trinity/chat/types/entity-pages';
import { buildDisplayrDashboardUrl } from './DisplayrDashboard';

/**
 * Where a dashboard can be opened outside the app, or null when it has no page of its own (Sigma views are
 * signed per viewer). The result is unchecked: DashboardCard only links http(s) URLs.
 */
export const getDashboardExternalUrl = (providerData: EntityDashboardProviderData): string | null => {
  switch (providerData.provider) {
    case 'displayr':
      return buildDisplayrDashboardUrl(providerData.dashboardId);
    case 'tableau':
      return providerData.url;
    case 'sigma':
    default:
      return null;
  }
};
